//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { MembershipPlanCurrencyCode } from './Enums';

export class MembershipPlanSearchOptions extends ItemBase {
    IDs: string[] = [];
    Currencies: MembershipPlanCurrencyCode[] = [];
    MinimumNumberOfMonthsBetweenRecurrence: number | null = null;
    MaximumNumberOfMonthsBetweenRecurrence: number | null = null;
    MinimumNumberOfTeachers: number | null = null;
    MaximumNumberOfTeachers: number | null = null;

    constructor(initializer?: Partial<MembershipPlanSearchOptions>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "MembershipPlanSearchOptions";
}
